export default "__VITE_ASSET__MzNchCWR__"